import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "xpage-search-results-buttons" }
const _hoisted_2 = ["onClick"]

import { useSearchPageStore } from "@/store/store/searchPageStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchResultsButtons',
  setup(__props) {

const searchPageStore = useSearchPageStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(searchPageStore).searchPageState.search.active)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "xfilter-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
        _unref(searchPageStore).clearSearchbox();
        _unref(searchPageStore).triggerSearch(
          _unref(searchPageStore).searchPageState.entity,
          null,
          _unref(searchPageStore).searchPageState.query.pageNumber
        );
      })
        }, _toDisplayString("Search: " + _unref(searchPageStore).searchPageState.search.text), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchPageStore).selectedFilters(), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "xfilter-button",
        onClick: ($event: any) => (_unref(searchPageStore).clearFilter(item)),
        key: index
      }, _toDisplayString(item.name), 9, _hoisted_2))
    }), 128)),
    (_unref(searchPageStore).selectedFilters().length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "xfilter-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
        _unref(searchPageStore).clearAllFiltersAndSearch(
          _unref(searchPageStore).searchPageState.entity
        )
      )),
          "data-type": "clear"
        }, " Clear All "))
      : _createCommentVNode("", true)
  ]))
}
}

})